<template>
  <div v-if="settings.data" class="form-container row">
    <div v-for="(setting, key) in settings.data" :key="key" class="form-section-container col-12">
      <div class="row form-element-container">
        <div class="col-6">
          <h4>{{ setting.data.attributes.name }}</h4>
          <p>{{ setting.data.attributes.description }}</p>
          <div class="d-flex" v-if="mentionModule(setting)">
            <div class="flex-column me-1">Stammt aus Modul:</div>
            <relation-link :value="setting.data.relations.module"></relation-link>
          </div>
          <div class="d-flex" v-if="mentionFeature(setting)">
            <div class="flex-column me-1">Betrifft Feature:</div>
            <relation-link :value="setting.data.relations.feature"></relation-link>
          </div>
          <div v-for="(propName, prop) in setting.data.attributes.property_names" :key="prop">
            <h6 class="fw-bold">{{ propName }}</h6>
            <p class="small" style="opacity: 0.75">
              <i class="fa fa-circle-info"></i>
              {{ setting.data.attributes.property_descriptions[prop] ?? 'MISSING DESCRIPTION' }}
            </p>
          </div>
        </div>
        <div class="col-6 d-flex flex-column">
          <form-field
            v-if="setting.data.attributes.has_values"
            :id="parentModel.data.attributes.ucid + '-' + setting.data.attributes.key"
            :error="errors ? errors[setting.data.attributes.key] : null"
            :label="null"
            :name="setting.data.attributes.key"
            :property-elements="setting.data.attributes.property_components ?? settings.meta.propertyElements"
            :property-labels="setting.data.attributes.property_names"
            :property-resource-types="setting.data.attributes.property_resource_types ?? []"
            :resource-type="settings.meta.resourceType"
            :choices="setting.data.attributes.choices"
            :field-type="'json'"
            :value="setting.data.attributes['vals']"
            :element="settings.meta.elements['vals'].form"
            :disabled="setting.data.attributes.has_active_permission === false"
            @update:attribute="(value) => setting.data.attributes['vals'] = value"
          ></form-field>
          <div class="row pt-2" v-if="setting.data.attributes.has_media && !setting.data.attributes['media'].length">
            <div class="col position-relative media-container">
              <div class="d-flex align-items-center justify-content-center border position-relative media-element">
                <img :src="setting.data.attributes['fallback_media'].file_name" :title="'Fallback'" class="border mh-100 mw-100" />
              </div>
              <a :href="setting.data.attributes['fallback_media'].file_name" class="d-block border border-top-0 p-2 text-truncate" target="_blank">
                <i class="bi bi-paperclip"></i>
                <span :title="setting.data.attributes['fallback_media'].file_name">{{ setting.data.attributes['fallback_media'].file_name }}</span>
              </a>
            </div>
          </div>
          <form-field
            v-if="setting.data.attributes.has_media"
            :id="parentModel.data.attributes.ucid + '-' + setting.data.attributes.key + '-media'"
            :error="errors ? errors[setting.data.attributes.key] : null"
            :label="null"
            :name="setting.data.attributes.key + '-media'"
            :field-type="'media'"
            :value="setting.data.attributes['media']"
            :element="settings.meta.elements['media'].form"
            @update:media="(media) => updateMedia(setting, media)"
          ></form-field>
          <div v-if="setting.data.attributes.has_active_permission === false" class="text-muted">
            Diese Einstellung kann derzeit nicht aktiviert werden, da die dafür notwendige Berechtigung global deaktiviert ist: {{ setting.data.attributes.role_permission_key }}
          </div>
          <button
            class="btn btn-primary position-relative align-self-end mt-3"
            style="padding-left: 2.25rem"
            type="button"
            :disabled="setting.data.attributes.has_active_permission === false"
            @click="saveSetting(setting)"
          >
            Speichern
            <i class="fa-solid fa-floppy-disk position-absolute lh-1 start-0 ms-2"></i>
          </button>
        </div>
      </div>
      <hr class="border-1">
    </div>
  </div>
</template>

<script>
import FormField from "@kanrisha/components/Form/FormField";
import RelationLink from "@kanrisha/components/Elements/Display/RelationLink";
import useModels from "@kanrisha/composables/useModels";

export default {
  components: {
    RelationLink,
    FormField
  },
  props: {
    settings: { type: Object, default: () => {} },
    parentModel: { type: Object, default: () => {} },
  },
  emits: ['update:toast'],
  setup(props, { emit }) {
    const saveSetting = async (setting, event) => {
      let { storeModel } = useModels({ resourceType: 'settings' });
      let savedSetting = await storeModel(setting, 'settings');
      let toasts = [];
      if (savedSetting.errors ?? savedSetting.toasts) {
        toasts = savedSetting.errors ?? savedSetting.toasts;
      }
      toasts = JSON.parse(JSON.stringify(toasts));
      if (!toasts.length) {
        // todo: replace this with toast messages from backend, also i think updating the messages is broken on page level
        toasts.push({'type': 'success', 'message': `${savedSetting.data.attributes.name} wurde erfolgreich aktualisiert.`});
      }
      emit('update:toasts', toasts);
    }

    const updateMedia = (setting, mediaItems) => {
      setting.media = mediaItems;
      setting.data.attributes.media_ids = mediaItems.filter((item) => !item.remove).map((item) => item.id);
      setting.data.attributes.remove_media_ids = mediaItems
        .filter((item) => item.remove)
        .map((item) => item.id);
    };

    const mentionFeature = (setting) => {
      if (props.parentModel && props.parentModel.meta.resourceType !== 'features') {
        return true;
      }

      return setting.data.attributes.feature_id !== props.parentModel.data.attributes.ucid;
    }

    const mentionModule = (setting) => {
      if (props.parentModel && props.parentModel.meta.resourceType !== 'modules') {

        return setting.data.attributes.module_id !== props.parentModel.data.attributes.origin_module_id;
      }

      return setting.data.attributes.module_id !== props.parentModel.data.attributes.ucid;
    }

    return {
      mentionFeature,
      mentionModule,
      saveSetting,
      updateMedia,
    };
  },
};
</script>